import { axios } from "../../lib/axios";

export const DeletePackage = (packageId: string) => {
    return axios.delete(`/package/${packageId}`)
        .then(response => response.data);
};